import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {ReactComponent as TrendUpIcon} from "assets/img/trend-up.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function StatisticItem(props) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    if (!hasAuthorization(currentMemberAuthorizations, Authorizations.STATISTICS_OPE)) {
        return null;
    }

    return (
        <SidebarItem
            isTopLevel
            icon={<TrendUpIcon />}
            to={MarketplaceRoutes.STATISTICS_OPE}
            selected={currentPath === MarketplaceRoutes.STATISTICS_OPE}
        >
            <FormattedMessage id='sidebar.item.ope' />
        </SidebarItem>
    );
}

export default StatisticItem;
